import {
  AngleDown,
  ChakraButton,
  ChakraMenu,
  ChakraMenuButton,
  ChakraMenuItem,
  ChakraMenuList,
  EquipUIFireflyV2Theme,
  Filter,
} from '@equip.health/ui';

import Header from '~/components/common/Header';

import TaskFilterMenu from './TaskFilterMenu';

const { primary } = EquipUIFireflyV2Theme.colors;

export interface TasksHeaderProps {
  organizeOptions: SelectOption[];
  organizeValue: string;
  onOrganizeSelect: (value: string) => void;
  categories: AutoCompleteOption[];
  getTasks: (params: Record<string, string | string[]>) => void;
  filters: TTaskFilters;
}

export const BUTTON_HEIGHT = 52;

const TasksHeader = ({
  categories,
  getTasks,
  organizeOptions,
  organizeValue,
  onOrganizeSelect,
  filters,
}: TasksHeaderProps) => (
  <Header
    actions={
      <>
        <ChakraMenu>
          <ChakraMenuButton
            as={ChakraButton}
            background="neutral.background.secondary"
            borderRadius="16px"
            fontSize="14px"
            fontWeight="700"
            height={`${BUTTON_HEIGHT}px`}
            rightIcon={<AngleDown fill={primary[100]} fillOpacity={1} />}
            textColor="gray.500"
          >
            {organizeValue}
          </ChakraMenuButton>
          <ChakraMenuList>
            {organizeOptions.map(({ label, value }: SelectOption) => (
              <ChakraMenuItem
                key={value}
                onClick={() => onOrganizeSelect(value)}
              >
                {label}
              </ChakraMenuItem>
            ))}
          </ChakraMenuList>
        </ChakraMenu>
        <ChakraMenu closeOnSelect={false} flip={false}>
          {({ isOpen, onClose }) => (
            <>
              <ChakraMenuButton
                as={ChakraButton}
                background="neutral.background.secondary"
                borderRadius="16px"
                fontSize="14px"
                fontWeight="700"
                height={`${BUTTON_HEIGHT}px`}
                marginLeft="16px"
                minWidth="fit-content"
                rightIcon={
                  <Filter fill={primary[100]} height="16px" width="16px" />
                }
                textColor="gray.500"
              >
                Filter by
              </ChakraMenuButton>
              <TaskFilterMenu
                categories={categories}
                filters={filters}
                getTasks={getTasks}
                handleClose={onClose}
                isOpen={isOpen}
              />
            </>
          )}
        </ChakraMenu>
      </>
    }
    title="Tasks list"
  />
);

export default TasksHeader;
